<app-loading-indicator-full *ngIf="showLoadingIndicator"></app-loading-indicator-full>
<app-reset-password-form [token]="token" *ngIf="showForm"></app-reset-password-form>
<div *ngIf="showFailMessage">
  <div class="card-body">
    <p>{{'message.reset-password-token-validation-fail'|translate}}</p>
  </div>
  <div class="card-footer">
    <button routerLink="/landing" class="btn btn-primary"><span class="mdi mdi-arrow-left-thick"></span></button>
  </div>
</div>
